export class GroupStatusRequest {
    groupId: number;
    active: boolean;
}